import { Link } from "react-router-dom";
import InfoBanner from "@/pages/quiz/base/components/footerAB/components/infoBanner";
import { ReactComponent as Check } from "@/assets/icons/check.svg";
import { useIsABTest } from "@/hooks/useIsABTest";
import { Reviews } from "@/pages/quiz/base/components/footerAB/components/reviews";
import legitscript from "@/assets/icons/legit-script.png";

const list = [
  `State-licensed 503A\nCompounding Pharmacy`,
  `Reviewed by Board-Certified\nMedical Professionals`,
  `United States Pharmacopeia\n(USP) Compliance Guaranteed`,
];

export const FooterAb = () => {
  const { isABTest_10_1_USP, isABTest_10_2_USP } = useIsABTest();

  return (
    <footer className="w-full bg-dark-purple-2 flex flex-col">
      {!isABTest_10_1_USP && !isABTest_10_2_USP && (
        <div className="border-b border-purple10 flex min-h-[116px] flex-col items-center justify-center gap-4 px-4 py-6 md:flex-row md:items-stretch md:p-0 md:gap-0">
          {list.map((item, index) => (
            <div
              key={index}
              className="flex w-[300px]  flex-row items-start justify-start gap-3 text-left md:w-auto md:flex-1 md:items-center md:justify-center md:border-r border-purple10 last:md:border-0"
            >
              <Check className="mt-[2px]" />
              <p className="text-white font-semibold leading-[100%] whitespace-pre-wrap">
                {item}
              </p>
            </div>
          ))}
        </div>
      )}
      <div className="flex items-center justify-around min-h-[133px] flex-row md:flex-nowrap flex-wrap gap-x-4 gap-y-8 w-full mx-auto py-8 px-4 gap-6 md:p-0">
        {!isABTest_10_2_USP && <Reviews />}
        <div className="flex items-center justify-center w-full sm:w-auto">
          <InfoBanner />
        </div>
        <Link
          to={`https://www.legitscript.com/websites/?checker_keywords=skinnyrx.com`}
          title="Verify LegitScript Approval"
        >
          <img
            src={legitscript}
            loading="lazy"
            alt="Legit approved"
            className="h-[64px] w-[60px] object-contain"
          />
        </Link>

        {/* <a
          aria-label="DMCA.com Protection Status"
          href="https://www.dmca.com/Protection/Status.aspx?ID=65a7a448-3498-412c-80be-4367c40594f6"
          title="DMCA.com Protection Status"
          className="dmca-badge"
        >
          <img
            src="https://images.dmca.com/Badges/dmca-badge-w250-5x1-04.png?ID=65a7a448-3498-412c-80be-4367c40594f6"
            alt="DMCA.com Protection Status"
            loading="lazy"
            className="h-[40px] w-[200px] object-contain"
          />
        </a> */}
      </div>
    </footer>
  );
};
